import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SignUp } from '@clerk/clerk-react';
import { shouldSkipOnboarding } from '../utils/roles';
import { useAuth } from '../contexts/AuthContext';
import AuthShell, { clerkAppearance } from '../components/auth/AuthShell';

const RegisterPage: React.FC = () => {
  const { isAuthenticated, user, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading || !isAuthenticated || !user) return;
    navigate(
      user.onboarding_completed || shouldSkipOnboarding(user) ? '/dashboard' : '/onboarding'
    );
  }, [isAuthenticated, user, isLoading, navigate]);

  return (
    <AuthShell title="Inscription" subtitle="Créez votre compte JULIA">
      <SignUp
        routing="path"
        path="/register"
        signInUrl="/login"
        forceRedirectUrl="/creer-organisation"
        fallbackRedirectUrl="/creer-organisation"
        appearance={clerkAppearance}
      />
    </AuthShell>
  );
};

export default RegisterPage;
